import { Component, Input } from '@angular/core';

@Component({
  selector: 'trip-history-widget',
  templateUrl: './trip-history-widget.component.html',
  styleUrls: ['./trip-history-widget.component.scss']
})
export class TripHistoryWidgetComponent {
  @Input() title: string;
  @Input() fullBleed = false;

  constructor() { }
}
